import { useEffect, useState } from 'react'
import { KnowledgeBaseItem, ChatMessage, ChatSession } from '../interfaces'
import api from '../../../../helpers/apiRequester'
import Notiflix from 'notiflix'
import { Confirm } from 'notiflix/build/notiflix-confirm-aio'
// import { Prompt } from 'notiflix/build/notiflix-prompt-aio'

export const useKnowledgeBase = (setSelectedTabIndex?: (index: number) => void) => {
    const [supremeCourtSession, setSupremeCourtSession] = useState<ChatSession>({
        sessionId: null,
        messages: [],
    })
    const [financialOmbudsmanSession, setFinancialOmbudsmanSession] = useState<ChatSession>({
        sessionId: null,
        messages: [],
    })
    const [knowledgeBaseItems, setKnowledgeBaseItems] = useState<KnowledgeBaseItem[]>([])

    useEffect(() => {
        const fetchKnowledgeBaseItems = async () => {
            const response = await api.get('/knowledge-base/get-supreme-court-items')

            console.log('response', response)
            const items = response.data.map((item: any) => ({
                ...item,
                createdAt: new Date(item.created_at).toISOString(),
            }))
            setKnowledgeBaseItems(items)
        }

        fetchKnowledgeBaseItems()
    }, [])

    const saveConversation = async (session: ChatSession, source: 'supreme-court' | 'financial-ombudsman') => {
        if (session.messages.length === 0) return

        Notiflix.Loading.pulse()
        const sourceLabel = source === 'supreme-court' ? 'Supreme Court' : 'Financial Ombudsman'

        const conf = await Confirm.prompt(
            'Save Conversation',
            'Enter a title for this conversation:',
            `${sourceLabel} Conversation - ${new Date().toLocaleDateString()}`,
            'Save',
            'Cancel',
            async (answer) => {
                const newItem: KnowledgeBaseItem = {
                    id: Date.now().toString(),
                    sessionId: session.sessionId || null,
                    title: answer,
                    type: 'conversation',
                    source: source,
                    messages: session.messages,
                    createdAt: new Date().toISOString(),
                }

                console.log('newItem', newItem)
                const response = await api.post('/knowledge-base/save-supreme-court-chat', {
                    knowledgeBaseItem: newItem,
                })
                console.log('saved response', response)

                setKnowledgeBaseItems((prev) => [newItem, ...prev])

                Notiflix.Loading.remove()
                Notiflix.Notify.success(`${sourceLabel} conversation saved to knowledge base!`)
            },
            () => {
                Notiflix.Loading.remove()
                Notiflix.Notify.failure('Conversation not saved')
                return
            }
        )
    }

    const saveSupremeCourtConversation = () => {
        saveConversation(supremeCourtSession, 'supreme-court')
    }

    const saveFinancialOmbudsmanConversation = () => {
        saveConversation(financialOmbudsmanSession, 'financial-ombudsman')
    }

    const clearSupremeCourtSession = () => {
        setSupremeCourtSession({
            sessionId: null,
            messages: [],
        })
    }

    const clearFinancialOmbudsmanSession = () => {
        setFinancialOmbudsmanSession({
            sessionId: null,
            messages: [],
        })
    }

    const handleDeleteItem = async (id: string) => {
        console.log('id', id)

        if (window.confirm('Are you sure you want to delete this item?')) {
            const response = await api.post(`/knowledge-base/delete-supreme-court-item`, { id: id })
            console.log('response', response)
            setKnowledgeBaseItems((prev) => prev.filter((item) => item.id !== id))
            Notiflix.Notify.success('Item deleted successfully')
        }
    }

    const handleDownloadItem = (item: KnowledgeBaseItem) => {
        // const blob = new Blob([item.content], { type: 'text/plain' })
        // const url = URL.createObjectURL(blob)
        // const a = document.createElement('a')
        // a.href = url
        // a.download = `${item.title}.txt`
        // document.body.appendChild(a)
        // a.click()
        // document.body.removeChild(a)
        // URL.revokeObjectURL(url)
        //TODO download item
    }

    const handleViewItem = async (item: KnowledgeBaseItem) => {
        //TODO

        Notiflix.Loading.pulse()
        const response = await api.post(`/knowledge-base/view-supreme-court-item`, { id: item.id })
        console.log('response', response)
        setSupremeCourtSession({
            sessionId: response.data.conversation.session_id,
            messages: response.data.messages,
        })

        // Switch to Supreme Court tab to display the conversation
        if (setSelectedTabIndex) {
            setSelectedTabIndex(0)
        }

        Notiflix.Loading.remove()
    }

    return {
        // State
        supremeCourtSession,
        setSupremeCourtSession,
        financialOmbudsmanSession,
        setFinancialOmbudsmanSession,
        knowledgeBaseItems,
        setKnowledgeBaseItems,

        // Actions
        saveSupremeCourtConversation,
        saveFinancialOmbudsmanConversation,
        clearSupremeCourtSession,
        clearFinancialOmbudsmanSession,
        handleDeleteItem,
        handleDownloadItem,
        handleViewItem,
    }
}
